const AVAILABLE_UNITS_COMPONENT = document.querySelector('.available-units-component');
if (AVAILABLE_UNITS_COMPONENT) {
    async function getAvailData() {
        const LOADER_WRAPPER = document.createElement('div');
        LOADER_WRAPPER.classList.add('loader-wrapper');
        const LOADER = document.createElement('div');
        LOADER.classList.add('loader');
        const LOADER_TITLE = document.createElement('div');
        LOADER_TITLE.classList.add('loader-title');
        LOADER_WRAPPER.appendChild(LOADER_TITLE);
        LOADER_WRAPPER.appendChild(LOADER);
        LOADER_TITLE.textContent = document.querySelector('.loading-message').value;
        //Error
        const ERROR_WRAPPER = document.createElement('div');
        const ERROR_TITLE = document.createElement('div');
        ERROR_WRAPPER.classList.add('error-wrapper');
        ERROR_TITLE.classList.add('error-title');
        ERROR_TITLE.textContent = document.querySelector('.error-message').value;
        ERROR_WRAPPER.appendChild(ERROR_TITLE);
        AVAILABLE_UNITS_COMPONENT.appendChild(LOADER_WRAPPER);
        const NUMB_PER_PAGE = document.querySelector('.num-per-page').value;
        const AVAIL_UNIT_ID = document.querySelector('.available-units-id').value;
        let response = await fetch(
            `${APIPrefix.get()}/search_api/availableunits?noOfItemsPerPage=${NUMB_PER_PAGE}&componentDataSourceId=${AVAIL_UNIT_ID}`
        );
        if (!response.ok) {
            AVAILABLE_UNITS_COMPONENT.removeChild(LOADER_WRAPPER);
            AVAILABLE_UNITS_COMPONENT.appendChild(ERROR_WRAPPER);
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        AVAILABLE_UNITS_COMPONENT.removeChild(LOADER_WRAPPER);
        let data = await response.json();
        return data;
    }

    getAvailData()
        .then((data) => {
            const HEADINGS = data.data.headings;
            const ITEMS = data.data.items;
            const CONFIGURATION = data.data.configuration;
            const LEGEND_KEY = data.data.legend;
            const LEGEND_WRAPPER = document.querySelector('.color-code-wrapper');
            const LEGEND_TITLE = document.createElement('span');
            LEGEND_TITLE.classList.add('title');
            LEGEND_TITLE.innerText = 'Key';
            LEGEND_WRAPPER.appendChild(LEGEND_TITLE);
            LEGEND_KEY.forEach((key) => {
                const KEY_BTN = document.createElement('button');
                KEY_BTN.innerText = key.type;
                KEY_BTN.style.backgroundColor = key.color;
                LEGEND_WRAPPER.appendChild(KEY_BTN);
            });

            const TABLE_WRAPPER = document.querySelector('.available-units-component .table-wrapper');
            const TABLE = document.createElement('table');
            TABLE.setAttribute('class', 'pagination');
            TABLE_WRAPPER.appendChild(TABLE);

            for (const field in data.data) {
                const THEAD = document.createElement('thead');
                const TABLE_ROW = document.createElement('tr');
                THEAD.appendChild(TABLE_ROW);
                const TBODY = document.createElement('tbody');

                if (field == 'headings') {
                    for (const child in HEADINGS) {
                        const HEADER_CELL = document.createElement('th');
                        TABLE_ROW.appendChild(HEADER_CELL);
                        HEADER_CELL.innerText = HEADINGS[child];
                        TABLE.appendChild(THEAD);
                    }
                } else if (field == 'items') {
                    for (const child in ITEMS) {
                        const TABLE_ROW = document.createElement('tr');
                        let item = ITEMS[child].fields;
                        for (const row in item) {
                            const TABLE_DATA = document.createElement('td');
                            TABLE_ROW.appendChild(TABLE_DATA);
                            if (Array.isArray(item[row])) {
                                for (const obj in item[row]) {
                                    let button = document.createElement('button');
                                    LEGEND_KEY.forEach((key) => {
                                        if (item[row][obj].type === key.type) {
                                            button.style.setProperty('background-color', key.color);
                                        }
                                    });
                                    button.innerText = item[row][obj].name;
                                    TABLE_DATA.appendChild(button);
                                }
                            } else if (typeof item[row] === 'object' && item[row].url !== undefined) {
                                if (item[row].url !== '') {
                                    let link = document.createElement('a');
                                    link.setAttribute('class', 'link--default');
                                    link.setAttribute('target', '_blank');
                                    link.setAttribute('href', item[row].url);
                                    link.innerHTML = item[row].name;
                                    TABLE_DATA.appendChild(link);
                                } else {
                                    let link = document.createElement('span');
                                    link.innerHTML = item[row].name;
                                    TABLE_DATA.appendChild(link);
                                    TBODY.appendChild(TABLE_ROW);
                                    TABLE.appendChild(TBODY);
                                }
                            } else {
                                TABLE_ROW.appendChild(TABLE_DATA);
                                TABLE_DATA.innerHTML = item[row];
                                TBODY.appendChild(TABLE_ROW);
                                TABLE.appendChild(TBODY);
                            }
                        }
                    }
                }
            }

            let dataTable = tableUtils.initPaginatedDataTable(TABLE_WRAPPER, CONFIGURATION, true, false);

            if (ITEMS === undefined || ITEMS.length == 0) {
                let ERROR_MSG = document.createElement('span');
                ERROR_MSG.innerText = CONFIGURATION.headerTemplateMessage;
                ERROR_MSG.setAttribute('class', 'no-items');
                LEGEND_WRAPPER.style.display = 'none';
                AVAILABLE_UNITS_COMPONENT.appendChild(ERROR_MSG);
                let TABLE_WRAP = document.querySelector('.table-wrapper');
                TABLE_WRAP.style.display = 'none';
                dataTable.destroy();
            } else {
                let paginationWrapper = TABLE_WRAPPER.querySelector('.dataTable-pagination');
                if (paginationWrapper && paginationWrapper.hasChildNodes()) {
                    tableUtils.initPaginationControlStates(dataTable, paginationWrapper);
                }        
            }
        })
        .catch((e) => console.log(e));
}